module.exports = __webpack_public_path__ + "SP_SPS5-Freetime-16689d5af735fba67bcf950bcd538a8f.png";